import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex flex-wrap w-full space-y-2 md:space-x-2 md:flex-nowrap md:space-y-0" }
const _hoisted_3 = { class: "flex w-full md:w-2/5" }
const _hoisted_4 = ["onKeydown"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)
const _hoisted_6 = { class: "w-full space-x-2 md:w-1/5" }
const _hoisted_7 = { class: "mt-8 overflow-x-auto min-h-[420px]" }
const _hoisted_8 = { class: "w-full table-auto" }
const _hoisted_9 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = { class: "relative flex items-center justify-between" }
const _hoisted_12 = { class: "flex items-center space-x-1" }
const _hoisted_13 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_14 = { class: "relative flex items-center justify-between" }
const _hoisted_15 = { class: "flex items-center space-x-1" }
const _hoisted_16 = { class: "px-2 py-2" }
const _hoisted_17 = { class: "relative flex items-center justify-between" }
const _hoisted_18 = { class: "flex items-center space-x-1" }
const _hoisted_19 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_20 = { class: "relative flex items-center justify-between" }
const _hoisted_21 = { class: "flex items-center space-x-1" }
const _hoisted_22 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_23 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_24 = { class: "px-2 py-2 capitalize" }
const _hoisted_25 = { class: "px-2 py-2 capitalize" }
const _hoisted_26 = { class: "px-2 py-6 space-x-2 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_27 = { class: "px-2 py-2" }

import { ref } from "vue";

import RoleGuard from "../RoleGuard.vue";
import TitleHeader from "../TitleHeader.vue";
import ExternalLink from "../ExternalLink.vue";
import TimezoneSpan from "../TimezoneSpan.vue";
import FilterTableHeader from "../tables/FilterTableHeader.vue";
import SortableTableHeader from "../tables/SortableTableHeader.vue";
import PaginationBar from "@/components/PaginationBar.vue";


import api from "../../api/api";
import { User, Survey, PaginationMeta } from "../../types";
import { useRoute } from "vue-router";
import { useFilters } from "@/composables/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainingSurveyList',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const { filters, setFilter, resetFilters, sortBy, getFiltersFromQuery, setFilterNoRefresh } = useFilters(route);

const surveys = ref([] as Survey[]);
const meta = ref({} as PaginationMeta);
const trainers = ref([] as { key: string; value: string }[]);


async function search() {
  const response = await api.surveys.listSurveys(filters.value)
  surveys.value = response.data;
  meta.value = response.meta;
  const trainersResponse = await api.surveys.listSurveysTrainers();
  trainers.value = trainersResponse.data.map((t: User) => ({ key: `${t.first_name} ${t.last_name}`, value: `${t.id}` }));
}

setFilterNoRefresh("sort", "first_event_date ");
setFilterNoRefresh("dir", "desc");
getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('training-feedback')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            id: "search",
            onKeydown: _withKeys(search, ["enter"]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).query) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-l",
            placeholder: "Search ...",
            required: ""
          }, null, 40, _hoisted_4), [
            [_vModelText, _unref(filters).query]
          ]),
          _createElementVNode("button", {
            onClick: search,
            class: "flex items-center h-10 px-4 py-2 space-x-2 text-white rounded-r whitespace-nowrap bg-primary hover:bg-blue-700"
          }, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("search")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
            default: _withCtx(() => [
              _createVNode(ExternalLink, {
                label: _ctx.$t('add-new-survey'),
                href: "https://app.smartsurvey.co.uk/",
                type: "button"
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("tr", _hoisted_9, [
            _createElementVNode("th", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.$t(`course-name`)) + " ", 1),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(SortableTableHeader, {
                    column: "name",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t(`location`)) + " ", 1),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(SortableTableHeader, {
                    column: "host_country",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createTextVNode(_toDisplayString(_ctx.$t(`trainer`)) + " ", 1),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(SortableTableHeader, {
                    column: "users.last_name",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"]),
                  _createVNode(FilterTableHeader, {
                    label: "trainerId",
                    currentValue: _unref(filters).trainerId,
                    filters: trainers.value,
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters),
                    "is-object-array": true
                  }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.$t(`course-date`)) + " ", 1),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(SortableTableHeader, {
                    column: "first_event_date",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ])
            ]),
            _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('actions')), 1)
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveys.value, (survey) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 divide-x divide-gray-300",
                key: survey.id
              }, [
                _createElementVNode("td", _hoisted_23, _toDisplayString(survey.name), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(survey.host_country), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(survey.owner?.first_name) + " " + _toDisplayString(survey.owner?.last_name), 1),
                _createElementVNode("td", _hoisted_26, [
                  _createVNode(TimezoneSpan, {
                    date: survey.first_event_date,
                    locale: "en-GB",
                    "date-style": "short",
                    "time-style": "short",
                    showTime: false
                  }, null, 8, ["date"])
                ]),
                _createElementVNode("td", _hoisted_27, [
                  _createVNode(_component_router_link, {
                    to: `/dashboard/training-feedback/${survey.id}`,
                    class: "text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
    ])
  ], 64))
}
}

})